import { render, staticRenderFns } from "./HtmlBlockDrawer.vue?vue&type=template&id=2c3a111c&scoped=true"
import script from "./HtmlBlockDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./HtmlBlockDrawer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HtmlBlockDrawer.vue?vue&type=style&index=0&id=2c3a111c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3a111c",
  null
  
)

export default component.exports